module.exports = __webpack_public_path__ + "static/media/herstellingen_v2.8a65bd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/images/herstellingen_v2.png
// module id = 362
// module chunks = 0